import React, { useCallback } from 'react';
import SideMenu from '../SideMenu/SideMenu';
import { AccountType, Privilege } from '../../api';
import AccountSidemenuFilter from './AccountSidemenuFilter';
import { withRouter, RouteComponentProps } from 'react-router';
import useHasPrivilege from '../Util/useHasPrivilege';

interface Props extends RouteComponentProps {
  onSearch: (search: String) => void;
  search?: string | undefined;
  accounts: Array<any>;
  types: any;
  onChangeTypes: any;
}

const AccountSidemenu: React.FunctionComponent<Props> = (props) => {
  const { accounts, types } = props;
 
  const isAdmin = useHasPrivilege(Privilege.Admin);

  const onAddAccount = useCallback(() => {
    props.history.push('/account/new');
  }, [props.history]);

  const menuItems = accounts.map(account => {
    return {
      title: account.name + (account.accountType === AccountType.Labelling ? ' (L)' : ''),
      path: '/account/' + account.id,
      key: account.id,
    };
  });

  let filter;
  if (isAdmin) {
    filter = (
      <AccountSidemenuFilter
        search={props.search}
        types={types}
        onSearchChange={props.onSearch}
        onChangeTypes={props.onChangeTypes}
        onAddAccount={onAddAccount}
      />
    );
  }

  return <SideMenu menuItems={menuItems} filter={filter} />;
};

export default withRouter(AccountSidemenu);
